const config = {
  // URL del backend
  API_BASE_URL: 'https://test.solterosmexico.com/api',

  // ID de administrador configurable por variable de entorno
  ADMIN_ID: Number(process.env.REACT_APP_ADMIN_ID) || 150532,
  
  // Configuración de la aplicación
  APP_NAME: 'SolterosMexico',
  APP_VERSION: '1.0.0',
  
  // Configuración de paginación
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  
  // Configuración de imágenes
  DEFAULT_PROFILE_IMAGE: 'https://test.solterosmexico.com/site_images/default/avatar_default.png',
  IMAGE_PLACEHOLDER: 'https://test.solterosmexico.com/site_images/default/avatar_default.png',

  // Avatares por defecto basados en género (imágenes locales)
  DEFAULT_AVATARS: {
    'Hombre': 'https://test.solterosmexico.com/site_images/default/avatar_masculino.jpg',
    'Mujer': 'https://test.solterosmexico.com/site_images/default/avatar_femenino.jpg',
    'male': 'https://test.solterosmexico.com/site_images/default/avatar_masculino.jpg',
    'female': 'https://test.solterosmexico.com/site_images/default/avatar_femenino.jpg'
  },

  // Función helper para obtener avatar por defecto basado en género
  getDefaultAvatar: (gender) => {
    const avatars = {
      'Hombre': 'https://test.solterosmexico.com/site_images/default/avatar_masculino.jpg',
      'Mujer': 'https://test.solterosmexico.com/site_images/default/avatar_femenino.jpg',
      'male': 'https://test.solterosmexico.com/site_images/default/avatar_masculino.jpg',
      'female': 'https://test.solterosmexico.com/site_images/default/avatar_femenino.jpg'
    };
    return avatars[gender] || 'https://test.solterosmexico.com/site_images/default/avatar_default.png';
  },

  // Función helper para verificar si un usuario es admin
  isAdmin: (user) => {
    // Verificar por campo isAdmin o por ID específico
    return user && (user.isAdmin === true || user.id === config.ADMIN_ID);
  },
  
  // Estados de México
  MEXICAN_STATES: [
    "Extranjero", "Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas",
    "Chihuahua", "Ciudad de México", "Coahuila", "Colima", "Durango", "Estado de México",
    "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "Michoacán", "Morelos", "Nayarit",
    "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí",
    "Sinaloa", "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas"
  ],
  
  // Opciones simples para los dropdowns (solo visual)
  GENDER_OPTIONS: [
    { value: "Hombre", label: "Hombre" },
    { value: "Mujer", label: "Mujer" },
    { value: "No binario", label: "No binario" }
  ],

  // Opciones de "Yo soy X buscando Y" (para backend - NO CAMBIAR)
  SEXO_BUSCA_OPTIONS: [
    "Hombre buscando Mujer",
    "Mujer buscando Hombre",
    "Hombre buscando Hombre",
    "Mujer buscando Mujer",
    "No binario"
  ],

  // Construir sexoBusca a partir de "soy" y "busco"
  buildSexoBusca: (soyGender, buscoGender) => {
    // Si alguno es "No binario", devolver "No binario"
    if (soyGender === "No binario" || buscoGender === "No binario") {
      return "No binario";
    }
    // Construir la combinación completa
    return `${soyGender} buscando ${buscoGender}`;
  },

  // Extraer "soy" del sexoBusca completo
  extractSoyFromSexoBusca: (sexoBusca) => {
    if (sexoBusca === "No binario") return "No binario";
    // Extraer la primera parte antes de " buscando "
    const parts = sexoBusca.split(" buscando ");
    return parts[0] || "Hombre";
  },

  // Extraer "busco" del sexoBusca completo
  extractBuscoFromSexoBusca: (sexoBusca) => {
    if (sexoBusca === "No binario") return "No binario";
    // Extraer la segunda parte después de " buscando "
    const parts = sexoBusca.split(" buscando ");
    return parts[1] || "Mujer";
  },

  // Función para invertir el valor de sexoBusca (para búsqueda)
  invertSexoBusca: (sexoBusca) => {
    const inversions = {
      "Hombre buscando Mujer": "Mujer buscando Hombre",
      "Mujer buscando Hombre": "Hombre buscando Mujer",
      "Hombre buscando Hombre": "Hombre buscando Hombre",
      "Mujer buscando Mujer": "Mujer buscando Mujer",
      "No binario": "No binario"
    };
    return inversions[sexoBusca] || sexoBusca;
  },
  
  // Configuración de validación
  MIN_AGE: 18,
  MAX_AGE: 100,
  MIN_PASSWORD_LENGTH: 6,
  
  // Configuración de tiempo
  SESSION_TIMEOUT: 24 * 60 * 60 * 1000, // 24 horas en milisegundos
  API_TIMEOUT: 30000, // 30 segundos (aumentado de 10 a 30)
  
  // Configuración de errores
  ERROR_MESSAGES: {
    NETWORK_ERROR: 'Error de conexión. Verifica tu internet.',
    API_ERROR: 'Error del servidor. Intenta más tarde.',
    VALIDATION_ERROR: 'Por favor verifica los datos ingresados.',
    AUTH_ERROR: 'Credenciales incorrectas.',
    NOT_FOUND: 'Recurso no encontrado.',
    UNAUTHORIZED: 'No tienes permisos para esta acción.',
    SERVER_ERROR: 'Error interno del servidor.',
    TIMEOUT_ERROR: 'El servidor está tardando en responder. Intenta de nuevo.'
  }
};

export default config;
